/* eslint-disable react/require-default-props */
import React from "react";
import PropTypes from "prop-types";
import { Alert } from "design-system";
import { ExclamationTriangleIcon } from "design-system/components/Icons";

export default function WarningBanner({ message, className = "" }) {
  if (!message?.trim()) {
    return null;
  }

  return (
    <Alert
      variant="warning"
      icon={<ExclamationTriangleIcon size={20} aria-hidden />}
      description={message.trim()}
      className={["ld-warning-banner", className].filter(Boolean).join(" ")}
    />
  );
}

WarningBanner.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};
